import { AccessToken, LocalBackendIdentityHeader } from './local-backend.types';

export function buildIdentityHeader(payload: AccessToken): LocalBackendIdentityHeader {
    const encodedToken = jwtEncode(payload);
    return `Bearer ${encodedToken}` as LocalBackendIdentityHeader;
}

function jwtEncode(payload: AccessToken): string {
    const header = { alg: 'HS256', typ: 'JWT' };
    const encodedHeader = base64url(JSON.stringify(header));
    const encodedPayload = base64url(JSON.stringify(payload));
    const encodedSignature = base64url(`${encodedHeader}${encodedPayload}dummy_signature`);
    return `${encodedHeader}.${encodedPayload}.${encodedSignature}`;
}

function base64url(value: string): string {
    return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
